import {
  CardBlockCardFragment,
  M54CardBlockFragment,
} from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { useQueryState } from 'next-usequerystate'
import React, { CSSProperties, FC, useRef } from 'react'
import CardBlockCard from './CardBlockCard/CardBlockCard'
import s from './M54CardBlock.module.scss'
import MobileFilter from './MobileFilter/MobileFilter'
interface Props extends M54CardBlockFragment {}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type M54CardBlockProps = Props & NativeAttrs

const M54CardBlock: FC<M54CardBlockProps> = ({
  className,
  cards,
  desktopColumns,
  mobileColumns,
  cardVariant,
  gutter,
  mobileGutter,
  enableTagFiltering,
}) => {
  const rootRef = useRef<HTMLDivElement>(null)
  const [tagFilter, setTagFilter] = useQueryState('category')
  const tags = [
    ...new Set(cards?.map((card: CardBlockCardFragment) => card.tags).flat()),
  ]
  return (
    <div className={clsx(className, s.root)} ref={rootRef}>
      {enableTagFiltering && (
        <>
          <ul className={s.filter}>
            <li
              onClick={() => setTagFilter(null)}
              data-active={!tagFilter}
              className={s.filterItem}
            >
              <div className={s.filterTag}>All</div>
            </li>
            {tags.map((tag) => (
              <li
                key={tag}
                onClick={() => setTagFilter(tag)}
                data-active={tagFilter === tag}
                className={s.filterItem}
              >
                <div className={s.filterTag}>{tag}</div>
              </li>
            ))}
          </ul>
        </>
      )}

      <ul
        className={s.grid}
        style={
          {
            '--gutter': gutter ? `${gutter}px` : undefined,
            '--m-gutter': mobileGutter ? `${mobileGutter}px` : undefined,
          } as CSSProperties
        }
      >
        {cards &&
          cards
            .filter((card: CardBlockCardFragment) =>
              enableTagFiltering
                ? !!tagFilter?.length
                  ? card.tags.includes(tagFilter)
                  : true
                : true,
            )
            .map((card, index) => (
              <CardBlockCard
                key={index}
                style={
                  {
                    '--columns': desktopColumns,
                    '--m-columns': mobileColumns,
                  } as CSSProperties
                }
                {...(card as CardBlockCardFragment)}
                variant={cardVariant}
              />
            ))}
      </ul>
      {enableTagFiltering && <MobileFilter rootRef={rootRef} tags={tags} />}
    </div>
  )
}

M54CardBlock.displayName = 'M54CardBlock'
export default M54CardBlock
